import { Serializable } from '@/models/core/serializable';

export class JgrowEventLikertScaleItem implements Serializable<JgrowEventLikertScaleItem> {
  ID: number; // ID
  questionID: number; // 設問ID
  value: number = 1;
  title: string = ''; // 選択肢文章
  validation: boolean = true;

  deserialize(input: any): JgrowEventLikertScaleItem {
    this.ID = input.ID;
    this.questionID = input.questionID;
    this.value = input.value;
    this.title = input.title;
    return this;
  }

  get isValid(): boolean {
    return this.validation;
  }

  get isValidError(): boolean {
    return !this.validation;
  }

  doValidation(): boolean {
    if (this.title == "" || this.title == null || this.title == undefined) {
      this.validation = false;
    } else {
      this.validation = true;
    }
    return this.validation;
  }
}
